<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/cost-center-widget/cost-center-widget.component.ts
-->
<ng-template #anchor></ng-template>
